@if (!notification.hide) {
  <mat-card class="notification-card">
    <div class="notification-content">
      @if (notification.closeNotification) {
        <button mat-icon-button (click)="close()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      }
      <!-- <div [innerHTML]="safeHtmlName" ></div> -->
      <div [innerHTML]="safeHtmlContent" class="message-content"></div>
    </div>
  </mat-card>
}
